import { useState, useRef, useEffect } from "react";

import { Pagination } from "react-bootstrap";

const AddRoundDropdown = ({ onAddRound }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleAddRound = (roundType) => {
    onAddRound(roundType);
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>
      <Pagination.Item
        key={"plus"}
        onClick={handleToggle}
        style={{ cursor: 'pointer' }}
      >
        +
      </Pagination.Item>
      
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '0px',
            background: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            minWidth: '140px',
            zIndex: 1060,
            marginTop: '2px'
          }}
        >
          <div
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              borderBottom: '1px solid #eee'
            }}
            onClick={() => handleAddRound('game')}
            onMouseOver={(e) => e.target.style.background = '#f8f9fa'}
            onMouseOut={(e) => e.target.style.background = 'white'}
          >
            🎮 Game Round
          </div>
          <div
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              borderBottom: '1px solid #eee'
            }}
            onClick={() => handleAddRound('question')}
            onMouseOver={(e) => e.target.style.background = '#f8f9fa'}
            onMouseOut={(e) => e.target.style.background = 'white'}
          >
            ❓ Question Round
          </div>
          <div
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              borderBottom: '1px solid #eee'
            }}
            onClick={() => handleAddRound('info')}
            onMouseOver={(e) => e.target.style.background = '#f8f9fa'}
            onMouseOut={(e) => e.target.style.background = 'white'}
          >
            ℹ️ Info Round
          </div>
        </div>
      )}
    </div>
  );
};

export default AddRoundDropdown; 